import axios from 'axios'
import store from '@/store'
import { getToken, removeToken, removeClient, removeReagentTeamInfo } from './auth'
import errorCode from './errorCode'
import { Message } from 'element-ui'
// 是否显示重新登录
export let isRelogin = { show: false };
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest'
// 创建axios实例
const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    baseURL: process.env.VUE_APP_BASE_API,
    // 超时
    timeout: 10000,
    // 设置跨域 Cookie
    withCredentials: true,
})
// request拦截器
service.interceptors.request.use(config => {
    store.commit('updateAjaxCount', 1)
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false
    if (getToken() && !isToken) {
        config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行编辑
    }
    // get请求映射params参数
    if (config.method === 'get' && config.params) {
        let url = config.url + '?';
        for (const propName of Object.keys(config.params)) {
            const value = config.params[propName];
            var part = encodeURIComponent(propName) + "=";
            if (value !== null && typeof (value) !== "undefined") {
                if (typeof value === 'object') {
                    for (const key of Object.keys(value)) {
                        if (value[key] !== null && typeof (value[key]) !== 'undefined') {
                            let params = propName + '[' + key + ']';
                            let subPart = encodeURIComponent(params) + '=';
                            url += subPart + encodeURIComponent(value[key]) + '&';
                        }
                    }
                } else {
                    url += part + encodeURIComponent(value) + "&";
                }
            }
        }
        url = url.slice(0, -1);
        config.params = {};
        config.url = url;
    }
    return config
}, error => {
    store.commit('updateAjaxCount', -1)
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    store.commit('updateAjaxCount', -1)
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode['default']
    if (code === 401) {
        removeToken()
        removeClient()
        removeReagentTeamInfo()
        store.commit("SET_TOKEN", undefined);
        store.commit("SET_LOGINFLAG", 0);
        // 登录失效后统一进入登录页，并保留当前访问地址用于成功回跳。
        if (!isRelogin.show && location.pathname !== '/login') {
            isRelogin.show = true;
            const redirect = location.pathname + location.search + location.hash;
            location.href = '/login?redirect=' + encodeURIComponent(redirect);
        }
        return Promise.reject(res.data)
    } else if (code === 500) {
        if (!res.config.suppressErrorMessage) {
            Message({
                message: msg,
                type: 'error'
            })
        }
        return Promise.reject(new Error(msg))
    } else if (code == 400 || code == 404 || code == 410 || code == 411 || code == 412) {
        if (!res.config.suppressErrorMessage) {
            Message({
                message: msg,
                type: 'error'
            })
        }
        return Promise.reject(msg)
    }
    // else if (code !== 200) {
    //   Notification.error({
    //     title: msg
    //   })
    //   return Promise.reject('error')
    // }
    else {
        return res.data
    }
},
    error => {
        store.commit('updateAjaxCount', -1)
        let { message } = error;
        if (message == "Network Error") {
            message = "后端接口连接异常";
        } else if (message.includes("timeout")) {
            message = "系统接口请求超时";
        } else if (message.includes("Request failed with status code")) {
            message = "系统接口" + message.substr(message.length - 3) + "异常";
        } else if (!error.config || !error.config.suppressErrorMessage) {
            Message({
              message: message,
              type: 'error',
              duration: 5 * 1000
            })
        }
        return Promise.reject(error)
    }
)

export default service